import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../../../../../environments/environment';
import { Post } from '../../../../../../models/post.model';
import { Product } from '../../../../../../models/product.model';
import { PostService } from '../../../../../../services/post.service';
import { ProductService } from '../../../../../../services/product.service';
import { NameValidator } from '../../../../validators/name.validator';
import { DatePipe } from '@angular/common';
import * as XLSX from "xlsx";
@Component({
  selector: 'app-pass-published',
  templateUrl: './pass-published.component.html',
  styleUrls: ['./pass-published.component.scss']
})
export class PassPublishedComponent implements OnInit {

  search: any;
  isFiltreDate: boolean;
  postTampons: Post[] = [];
  initialPosts: Post[] = [];
  shopID: string = '';
  //posts: PostProductServiceGiftInfos[] = [];
  posts: Post[] = [];
  postUpdate: Post = {};
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  product: Product = {};
  url_photo: string = environment.url_photo;
  @ViewChild('publication') publication;

  updateForm = this.fb.group({
    price: new FormControl('', [ Validators.required,Validators.minLength(3), Validators.maxLength(10), NameValidator.checkOnlyNumberValidator ]),
    description: new FormControl('',[Validators.minLength(18),Validators.maxLength(255)])
  });

  constructor(private route: ActivatedRoute,
              private postService: PostService,
              private productService: ProductService,
              private fb: FormBuilder, private router: Router, private datePipe: DatePipe,) { }

  ngOnInit(): void {
    this.shopID = this.route.snapshot.paramMap.get('shopID');
    //this.getPublicationsByShopID();
    this.getPublishedSubscribe();
  }

  getPublishedSubscribe(){
    this.postService.allPosts_v1(this.pageNumber-1, this.pageSize).subscribe(data => {
      this.posts = data.content;
      this.totalItems = data.totalElements;
     // console.log("Liste des publications...")
     // console.log(this.posts)
      this.initialPosts = this.posts;
      this.postTampons = this.posts;
      this.isFiltreDate = false;
    });
  }

  dateForm = this.fb.group({
    beginDate: ['', Validators.required],
    endDate: ['', Validators.required]
  })

  model = {
    description: ''
  };

  get post() { return this.updateForm.controls; }

  updatePublication(p: Post) {
    this.postService.getIdPostBack(p.id).subscribe(data => {
      this.postUpdate = data;

     // console.log( " this.postUpdate",this.postUpdate)
    })
    this.updateForm.patchValue({
      price: p.postSubProducts[0].finalPrice,
      description: p.description
    });
  }

  onFormSubmitPass() {
    this.postUpdate.description = this.updateForm.get('description').value;
    // console.log(this.postUpdate);
    this.postUpdate.postSubProducts[0].price = this.updateForm.get('price').value;
    //this.postUpdate.postProducts[0].product = this.product;

    //console.log(this.postUpdate);

    this.postService.updatePostBack(this.postUpdate).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Votre annonce a été modifiée avec succès',
        showConfirmButton: false,
        timer: 3500
      });
      this.clear();
      this.reloadComponent();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 1500
      })
    })
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  clear() {
    this.updateForm.patchValue({
      price: [],
      description: []
    });
    this.publication.hide();
    //this.getPublicationsByShopID();
    this.getPublishedSubscribe();
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  disablePost(id: number) {
    this.postService.inactivePost(id).subscribe(data => {
      Swal.fire({
        title: 'Publication désactivée avec succès',
        icon: 'success',
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000
      });
      // this.getPublicationsByShopID();
      this.reloadComponent();
    },error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la désactivation de la publication"',
        showConfirmButton: false,
        timer: 2000
      });
    });
  }

  enablePost(id: number) {
   this.postService.activePostBack(id).subscribe(data => {
     Swal.fire({
       title: 'Publication activée avec succès',
       icon: 'success',
       position: 'top-end',
       showConfirmButton: false,
       timer: 2000
     });
    //  this.getPublicationsByShopID();
    this.reloadComponent();
   },error => {
     Swal.fire({
       position: 'top-end',
       icon: 'error',
       title: 'Erreur lors de l\'activation de la publication"',
       showConfirmButton: false,
       timer: 2000
     });
   });
  }

  deletePost(post:any){
   // console.log("Id du post à supprimer");
   // console.log(post);
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette annonce ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#00a8bb',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postService.deletePostGiftCard(post).subscribe(
          rs=> {
            // console.log(rs)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre annonce est supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            window.setTimeout(() => {
              window.location.reload()
            }, 1000);
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur de suppression <br>'+error.error.errorMessage,
              showConfirmButton: false,
              timer: 4500
            })
          }
        )
      }
    })

  }


  ascendingOrderByLimitDate: boolean = true;
  // sortByLimitDate(){
  //   this.posts.sort((a, b) => {
  //     const nameA = this.getLimitDate(a);
  //     const nameB = this.getLimitDate(b);

  //     if(this.ascendingOrderByLimitDate){
  //       return nameA.localeCompare(nameB);
  //     }else {
  //       return nameB.localeCompare(nameA);
  //     }
  //   })
  //   this.ascendingOrderByLimitDate = !this.ascendingOrderByLimitDate;
  // }
  sortByPublishedAt(){
    this.posts.sort((a, b) => {
      const nameA = a.publishedAt.toString();
      const nameB = b.publishedAt.toString();

      if(this.ascendingOrderByLimitDate){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByLimitDate = !this.ascendingOrderByLimitDate;
  }

  postSearchText = "";
  statusSearchText = "";
  startDate = '';
  endDate = '';
  filterByStatus(event: any) {
    this.statusSearchText = event.target.value;
    // if (value == 'tous') {
    //   this.posts = this.initialPosts;
    // } else {
    //   this.posts = this.initialPosts.filter(result => {
    //     return result.status.name.includes(value);
    //   })
    // }
    this.postService.allPosts_v1(this.pageNumber-1, this.pageSize,this.startDate, this.endDate, this.postSearchText, this.statusSearchText).subscribe(data => {
      this.posts = data.content;
      this.totalItems = data.totalElements;
      this.isFiltreDate = false;
    });
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  areDatesEmpty(): boolean {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    return !beginDate && !endDate;
  }

  filterByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;

    // Vérifier si les deux champs de date sont vides
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    } else {
      const beginDateISO = new Date(beginDate).toISOString();
      const endDateISO = new Date(endDate).toISOString();
      // console.log("Date sélectionnée")
      // console.log('beginDate:', beginDateISO);
      // console.log('endDate:', endDateISO);
      this.postService.allPosts_v1(this.pageNumber-1, this.pageSize,beginDateISO, endDateISO, this.search, this.statusSearchText).subscribe(data => {
        this.posts = data.content;
        this.totalItems = data.totalElements;
        this.isFiltreDate = true;
      });
      // this.postService.allSubscribePostsByDate(beginDateISO, endDateISO, this.pageNumber - 1, this.pageSize).subscribe(data => {
      //   this.posts = data.content;
      //   this.totalItems = data.totalElements;
      //   this.isFiltreDate = true
      // });
    }
  }

  filterPostByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    if(beginDate == '' || endDate == ''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    let endDateTrans: any = new Date(endDate);
    endDateTrans.setDate(endDateTrans.getDate() + 1);
    endDateTrans = this.datePipe.transform(endDateTrans,'yyyy-MM-dd');
    // console.log(endDateTrans);

    this.posts = this.initialPosts.filter(p => {
      return (p.publishedAt >= beginDate) && (p.publishedAt <= endDateTrans);
    })
  }

  refresh() {
    this.getPublishedSubscribe();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }


  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.getPublishedSubscribe();
  }

  searchPost($event: KeyboardEvent) {    
    this.postService.allPosts_v1(this.pageNumber-1, this.pageSize,this.startDate, this.endDate, this.search, this.statusSearchText).subscribe(data => {
      this.posts = data.content;
      this.totalItems = data.totalElements;
      this.isFiltreDate = false;
    });
  }

  pagination(){
    if(this.isFiltreDate){
      this.filterByDate()
    }
    else{
      this.getPublishedSubscribe()
    }

  }

  ascendingByProductName: boolean = true;
  sortByProductName(){
    this.posts.sort((a, b) => {
      const nameA = a.title.toLowerCase();
      const nameB = b.title.toLowerCase();

      if(this.ascendingByProductName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByProductName = !this.ascendingByProductName;
  }

  ascendingByCategorie: boolean = true;
  sortByCategorie(){
    this.posts.sort((a, b) => {
      const nameA = a?.category?.name.toLowerCase();
      const nameB = b.category.name.toLowerCase();

      if(this.ascendingByCategorie){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingByCategorie = !this.ascendingByCategorie;
  }

  ascendingByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.posts.sort((a, b) => {
      const dateA = new Date(a.publishedAt);
      const dateB = new Date(b.publishedAt);
      if(this.ascendingByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingByCreatedDate = !this.ascendingByCreatedDate;
  }

  ascendingByPrice: boolean = true;
  sortByPrice() {
    this.posts.sort((a, b) => {
      const priceA = a.postSubProducts[0].finalPrice;
      const priceB = b.postSubProducts[0].finalPrice;
      if(this.ascendingByPrice){
        return priceA - priceB;
      }else{
        return priceB -priceA;
      }
    })
    this.ascendingByPrice = !this.ascendingByPrice;
  }

}
